module.exports = __webpack_public_path__ + "static/img/301_TO8_2004.c6b4e43.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/301_TO8_2004.jpg
// module id = 6XOj
// module chunks = 0